'use client';

import React from 'react';
import Tooltip from '@mui/material/Tooltip';

/**
 * Thin wrapper around MUI Tooltip with low hover delay for editor and list UIs.
 */
const FastTooltip = ({ title, children, ...props }) => {
  if (title == null || title === '') {
    return children;
  }

  return (
    <Tooltip
      title={title}
      enterDelay={150}
      enterNextDelay={100}
      disableInteractive
      {...props}
    >
      <span style={{ display: 'inline-flex', maxWidth: '100%' }}>{children}</span>
    </Tooltip>
  );
};

export default FastTooltip;
